export default "__VITE_ASSET__BJMVGmgo__"